module.exports = __webpack_public_path__ + "static/media/arrowUpAccordionIcon.8ca69f31.svg";